// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/activities/about.less
// module id = 391
// module chunks = 0